import { initializeApp } from 'firebase/app';
import { initializeAuth, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAEeYsyGZj48dVh9BK4Qm7yyChRV1fwEXg",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "schoolsync-bfccc",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "schoolsync-bfccc.firebaseapp.com",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "schoolsync-bfccc.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Auth — use localStorage persistence so Playwright tests can capture auth state
// (IndexedDB default can't be captured by Playwright's storageState)
export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
});

// Initialize Firestore with simpler caching strategy
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED
});

// Initialize Storage
export const storage = getStorage(app);